
import { Component, Vue } from 'vue-property-decorator'
import { IMockModule1Map, MOCK_MODULE1_MAP } from '@/constants/monitor-mock'

@Component({ name: 'DashboardModule1Map' })
export default class DashboardModule1Map extends Vue {
    private rows: IMockModule1Map[] = MOCK_MODULE1_MAP
}
